/* HH · Build-your-horse configurator.
   Two preview modes (section setting `live_preview` -> DATA.livePreview):
   ON  = layered live preview from Shopify Files (hh-cfg-manifest.js), only
         colours with layer sets (`layers:true`) selectable, others "Soon".
   OFF = static stage photo (DATA.staticImage or the Chestnut base render);
         every colour selectable, no Soon badges.

   Cart: DATA.cart.variants (rendered by Liquid from the hidden 16-variant
   pricing product) maps "Mane|Eyes|BlazeClass" -> {id, cents}. When present,
   prices come from those variants (display == checkout, market-exact) and
   add-to-cart POSTs /cart/add.js with CPB-compatible properties (Size/Color/
   Eyes/Blaze & Markings/Manes), then goes to /cart (Shop button -> /checkout).
   Without it: FX-converted EUR deltas + the labelled mock drawer.

   UX layer: crossfading layer swaps (double-buffered), shareable config URL
   (?size=&colour=&mane=&eyes=&markings=), localStorage restore, fullscreen
   zoom, "surprise me" shuffle, selection micro-feedback. Quantity is fixed
   at 1 on this page by design. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.hhcfgInit) return;
    root.dataset.hhcfgInit = '1';

    var dataEl = root.querySelector('#hhcfgData');
    if (!dataEl || !window.HHCFG_FILES) return;
    var DATA = JSON.parse(dataEl.textContent);
    var CFG = DATA.config;
    var FILES = window.HHCFG_FILES;
    var CDN = window.HHCFG_CDN;

    /* Localized option labels (DATA.labels, rendered per request.locale).
       o.en keeps the canonical English name — cart line item properties and
       fulfillment always receive English, whatever the storefront language. */
    ['sizes', 'colors', 'manes', 'eyes', 'blazes'].forEach(function (g) {
      CFG[g].forEach(function (o) {
        o.en = o.label;
        if (DATA.labels && DATA.labels[o.id]) o.label = DATA.labels[o.id];
      });
    });

    var LIVEPREV = !!DATA.livePreview;
    var CART = DATA.cart && DATA.cart.variants ? DATA.cart.variants : null;
    if (CART && !CART['Basic|None']) CART = null;   /* malformed product — fall back */

    if (CART) {
      /* Prices come straight from the hidden pricing product's variants
         (Eyes x Blaze class; manes are included in the base), so what we
         display is exactly what checkout charges in every market. */
      var cbase = CART['Basic|None'].cents;
      DATA.basePriceCents = cbase;
      var dEyes = CART['Hand-painted|None'].cents - cbase;
      CFG.eyes.forEach(function (o) { if (!o.incl) o.cents = dEyes; });
      CFG.blazes.forEach(function (o) {
        var cls = blazeClass(o.id);
        if (cls !== 'None') o.cents = CART['Basic|' + cls].cents - cbase;
      });
    } else {
      /* Option deltas are defined in EUR cents. The base price arrives from
         Liquid already converted to the market currency, so base/eurBase IS
         the exact Markets FX factor — apply it to the deltas and round to
         whole units. */
      var FX = DATA.basePriceCents / CFG.eurBaseCents;
      ['manes', 'eyes', 'blazes'].forEach(function (g) {
        CFG[g].forEach(function (o) { o.cents = Math.round(o.cents * FX / 100) * 100; });
      });
    }

    function blazeClass(id) {
      if (id === 'none') return 'None';
      if (id === 'blaze_markings') return 'Markings';
      if (id === 'blazemarkings') return 'Blaze & Markings';
      return 'Blaze, Snip or Star';
    }
    function comboKey() {
      return (state.eyes === 'eye_basic' ? 'Basic' : 'Hand-painted') + '|' + blazeClass(state.blaze);
    }
    function colorSelectable(o) { return LIVEPREV ? !!o.layers : true; }
    /* White ships WITHOUT felt (Pavel 2026-08-25) - a product decision, so it holds
       in static mode too, not just under the live preview. */
    function feltBlocked() { var c = by(CFG.colors, state.color); return !!(c && c.noFelt); }
    function normalize() { if (feltBlocked() && state.blaze !== 'none') state.blaze = 'none'; }

    var LAYER_W = window.matchMedia('(max-width: 991px)').matches ? 700 : 1000;
    function fileUrl(key, w) {
      var f = FILES[key.replace(/\.webp$/, '')];
      return f ? CDN + f + '?width=' + w : '';
    }

    /* ---------- money ---------- */
    function group(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmtCents(cents, noDec) {
      var f = DATA.moneyFormat || '€{{amount}}';
      var whole = Math.floor(cents / 100), dec = ('0' + (cents % 100)).slice(-2);
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, ph) {
        switch (ph) {
          case 'amount_no_decimals': return group(Math.round(cents / 100), ',');
          case 'amount_with_comma_separator': return noDec && dec === '00' ? group(whole, '.') : group(whole, '.') + ',' + dec;
          case 'amount_no_decimals_with_comma_separator': return group(Math.round(cents / 100), '.');
          default: return noDec && dec === '00' ? group(whole, ',') : group(whole, ',') + '.' + dec;
        }
      }).replace(/<[^>]*>/g, '');
    }
    function fmtDelta(cents) { return '+' + fmtCents(cents, true); }

    /* ---------- state + share URL + persistence ---------- */
    var state = Object.assign({ inCart: false }, CFG.defaults);
    var $ = function (id) { return root.querySelector('#' + id); };
    var by = function (arr, id) { return arr.find(function (o) { return o.id === id; }); };

    function slug(group, id) {
      if (group === 'color') return id.replace('base_', '');
      if (group === 'mane') return id.replace('mane_', '');
      if (group === 'eyes') return id.replace(/^eye_/, '').replace(/_w$/, '');
      if (group === 'blaze') return id === 'blazemarkings' ? 'blaze-markings' : id.replace('blaze_', '');
      return id;
    }
    var UNSLUG = { size: {}, color: {}, mane: {}, eyes: {}, blaze: {} };
    CFG.sizes.forEach(function (o) { UNSLUG.size[o.id] = o.id; });
    CFG.colors.forEach(function (o) { UNSLUG.color[slug('color', o.id)] = o.id; });
    CFG.manes.forEach(function (o) { UNSLUG.mane[slug('mane', o.id)] = o.id; });
    CFG.eyes.forEach(function (o) { UNSLUG.eyes[slug('eyes', o.id)] = o.id; });
    CFG.blazes.forEach(function (o) { UNSLUG.blaze[slug('blaze', o.id)] = o.id; });

    var PARAMS = { size: 'size', color: 'colour', mane: 'mane', eyes: 'eyes', blaze: 'markings' };
    function applyExternal(get) {
      Object.keys(PARAMS).forEach(function (k) {
        var v = get(k);
        if (v && UNSLUG[k][v]) state[k] = UNSLUG[k][v];
      });
      var col = by(CFG.colors, state.color);
      if (!col || !colorSelectable(col)) state.color = CFG.defaults.color;
    }
    try {
      var saved = JSON.parse(localStorage.getItem('hhcfg:v1') || 'null');
      if (saved) applyExternal(function (k) { return saved[k]; });
    } catch (e) { /* private mode */ }
    var qs = new URLSearchParams(location.search);
    applyExternal(function (k) { return qs.get(PARAMS[k]); });

    function persist() {
      var out = {};
      Object.keys(PARAMS).forEach(function (k) { out[k] = slug(k, state[k]); });
      try { localStorage.setItem('hhcfg:v1', JSON.stringify(out)); } catch (e) { /* ignore */ }
      var u = new URLSearchParams(location.search);
      Object.keys(PARAMS).forEach(function (k) {
        if (state[k] === CFG.defaults[k]) u.delete(PARAMS[k]);
        else u.set(PARAMS[k], out[k]);
      });
      var q = u.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
    }

    /* ---------- layer maths (shared by stage / drawer / zoom) ---------- */
    /* Static mode still swaps the BASE photo per colour — only the option
       layers (mane/blaze/eyes) are absent. */
    function staticUrl(w) {
      var b = DATA.bases && DATA.bases[state.color];
      if (b) return b;
      if (DATA.staticImage) return DATA.staticImage.replace(/([?&])width=\d+/, '$1width=' + w);
      return fileUrl('base_chestnut.webp', w);
    }
    function computeLayers(w) {
      if (!LIVEPREV) {
        return { Base: staticUrl(w), Blaze: null, Blaze2: null, Mane: null, Eye: null };
      }
      var b = state.color, blz = state.blaze;
      var bmStack = blz === 'blazemarkings';
      var suf = '';
      if (bmStack) suf = '_bm';
      else if (blz === 'blaze_markings') suf = '_mk';
      else if (blz === 'blaze_blaze') suf = '_bl';
      else if (blz === 'blaze_star') suf = '_st';
      var eye = by(CFG.eyes, state.eyes);
      return {
        Base: fileUrl(b + '.webp', w),
        Blaze: blz !== 'none' ? fileUrl((bmStack ? 'blaze_blaze' : blz) + '__' + b + '.webp', w) : null,
        Blaze2: bmStack ? fileUrl('blaze_markings__' + b + '.webp', w) : null,
        Mane: fileUrl(state.mane + '__' + b + suf + '.webp', w),
        Eye: eye.layer === null ? null :
          fileUrl(state.eyes + (CFG.bakedEyeBases.indexOf(b) > -1 ? '__' + b : '') + '.webp', w)
      };
    }

    /* ---------- stage: double-buffered crossfade ---------- */
    var SLOTS = ['Base', 'Blaze', 'Blaze2', 'Mane', 'Eye'];
    var stageEls = {};
    SLOTS.forEach(function (s) {
      stageEls[s] = { a: $('hhcfg' + s), b: $('hhcfg' + s + 'B'), url: null, gen: 0 };
    });
    function stageSet(slot, url) {
      var el = stageEls[slot];
      if (el.url === url) return;
      el.url = url;
      var gen = ++el.gen;
      if (!url) { el.a.classList.remove('on'); el.b.classList.remove('on'); return; }
      var incoming = el.a.classList.contains('on') ? el.b : el.a;
      var outgoing = incoming === el.a ? el.b : el.a;
      var img = new Image();
      img.onload = function () {
        if (gen !== el.gen) return;   /* superseded by a newer pick */
        incoming.src = url;
        incoming.classList.add('on');
        outgoing.classList.remove('on');
      };
      img.src = url;
    }
    function renderPreview() {
      var L = computeLayers(LAYER_W);
      SLOTS.forEach(function (s) { stageSet(s, L[s]); });
      var starOn = LIVEPREV && state.blaze === 'blaze_star';
      if (starOn) {
        var g = CFG.starGeom[state.color] || CFG.starGeom.base_black;
        var d = 'M 59 14.5 Q 40 11 ' + g.end[0] + ' ' + g.end[1];
        $('hhcfgArrA').setAttribute('d', d);
        $('hhcfgArrB').setAttribute('d', d);
        $('hhcfgStarInset').src = fileUrl(g.inset, 400);
      }
      $('hhcfgStar').classList.toggle('on', starOn);
    }

    /* ---------- price ---------- */
    function unitCents() {
      if (CART) {
        var v = CART[comboKey()];
        if (v) return v.cents;   /* the exact variant price checkout will charge */
      }
      return DATA.basePriceCents + by(CFG.manes, state.mane).cents +
        by(CFG.eyes, state.eyes).cents + by(CFG.blazes, state.blaze).cents;
    }
    function renderPrice() {
      var u = unitCents();
      var el = $('hhcfgPrice');
      el.textContent = fmtCents(u);
      if (!REDUCED) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
      var extras = u - DATA.basePriceCents;
      $('hhcfgDeltas').textContent = extras > 0 ? fmtCents(DATA.basePriceCents, true) + ' ' + fmtDelta(extras) : '';
      $('hhcfgMbarPrice').textContent = fmtCents(u);
      $('hhcfgSumTotal').textContent = fmtCents(u);
    }

    /* ---------- option groups ---------- */
    var TICK = '<span class="hhcfg-tick"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>';
    function echo(id, html) { var e = $(id); if (e) e.innerHTML = html; }
    function echoFor(o) {
      return '<b>' + o.label + '</b>' + (o.cents ? ' <span class="delta">' + fmtDelta(o.cents) + '</span>' : '');
    }
    function feedback() {
      if (navigator.vibrate && window.matchMedia('(pointer: coarse)').matches) navigator.vibrate(8);
    }
    function pick(key, id) { state[key] = id; feedback(); renderAll(); }

    function renderSizes() {
      /* 260909 parity: the exact DOM + classes of the PDP buy-box size cards (snippets/product-variant-options),
         inside a .main-product-scoped wrapper so main-product.css styles them 1:1; a hidden radio carries the
         checked state (the theme CSS draws the pink ring + check badge from input:checked + label) */
      var host = $('hhcfgOpts-size'); host.innerHTML = '';
      var wrap = document.createElement('div'); wrap.className = 'main-product hhcfg-sizewrap';
      var row = document.createElement('div'); row.className = 'variant-row variant-row--pills variant-row--size-cards';
      var holder = document.createElement('div'); holder.className = 'variant-options-holder';
      row.appendChild(holder); wrap.appendChild(row); host.appendChild(wrap);
      function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
      CFG.sizes.forEach(function (o, i) {
        var id = 'hhcfg-size-' + o.id, on = state.size === o.id;
        var box = document.createElement('div'); box.className = 'variant-options-wrap';
        var input = document.createElement('input'); input.type = 'radio'; input.id = id; input.name = 'hhcfg-size'; input.value = o.label; input.checked = on; input.className = '';
        input.addEventListener('change', function () { if (input.checked && state.size !== o.id) pick('size', o.id); });
        var label = document.createElement('label'); label.className = 'variant-element_label'; label.htmlFor = id; label.setAttribute('data-option-name', o.label); label.setAttribute('data-size', o.label);
        var bl = (o.bullets || []).filter(function (x) { return x && x.trim(); });
        var spec = '';
        if (o.meta) {
          var parts = o.meta.split(' • ').map(function (s) { return s.trim(); }).filter(Boolean);
          spec = '<span class="variant-element_spec' + (parts.length > 1 ? ' variant-element_spec--lines' : '') + '">' +
            parts.map(function (s) { return '<span>' + esc(s).replace(/\[([^\]]*)\]/g, '<em class="variant-element_spec-opt">$1</em>') + '</span>'; }).join('') + '</span>';
        }
        label.innerHTML = '<span class="variant-element_span"><span><b>' + esc(o.label) + '</b>' + (o.tag ? '<em class="variant-element_tag">' + esc(o.tag) + '</em>' : '') + '</span>' +
          (bl.length ? '<ul class="variant-element_hintlist">' + bl.map(function (x) { return '<li>' + esc(x.trim()) + '</li>'; }).join('') + '</ul>' : (o.desc ? '<span class="variant-element_hint">' + esc(o.desc) + '</span>' : '')) +
          spec + '</span>';
        box.appendChild(input); box.appendChild(label); holder.appendChild(box);
      });
      echo('hhcfgEcho-size', '<b>' + by(CFG.sizes, state.size).label + '</b>');
    }
    function swBtn(o, imgKey, sel, priceTxt, soon) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hhcfg-sw' + (sel ? ' on' : '') + (soon ? ' soon' : '');
      b.setAttribute('aria-pressed', !!sel);
      /* theme-asset overrides (e.g. mane-less colour heads) win over Files */
      var src = (DATA.swatches && DATA.swatches[imgKey.replace(/\.webp$/, '')]) || fileUrl(imgKey, 200);
      b.innerHTML = '<span class="im"><img src="' + src + '" alt="" loading="lazy">' +
        (soon ? '<span class="hhcfg-soonb">Soon</span>' : '') + '</span>' +
        '<span class="nm">' + o.label + '</span>' +
        (priceTxt ? '<span class="pr">' + priceTxt + '</span>' : '') + TICK;
      return b;
    }
    /* one shared surcharge for a whole group, or -1 when prices are mixed */
    function uniformDelta(arr) {
      var paid = arr.filter(function (o) { return !o.incl && o.cents > 0; });
      if (!paid.length) return 0;
      var c = paid[0].cents;
      return paid.every(function (o) { return o.cents === c; }) ? c : -1;
    }
    function renderColors() {
      var host = $('hhcfgOpts-color'); host.innerHTML = '';
      CFG.colors.forEach(function (o) {
        var b = swBtn(o, 'sw_' + o.id + '.webp', state.color === o.id, '', !colorSelectable(o));
        b.onclick = function () {
          if (!colorSelectable(o)) { toast(DATA.soonToast.replace('{label}', o.label)); return; }
          pick('color', o.id);
        };
        host.appendChild(b);
      });
      echo('hhcfgEcho-color', '<b>' + by(CFG.colors, state.color).label + '</b>');
    }
    function renderManes() {
      var host = $('hhcfgOpts-mane'); host.innerHTML = '';
      var u = uniformDelta(CFG.manes);   /* uniform surcharge -> note in the header, no per-swatch price */
      CFG.manes.forEach(function (o) {
        var priceTxt = u === -1 ? (o.incl ? DATA.included : fmtDelta(o.cents)) : '';
        var b = swBtn(o, 'sw_' + o.id + '.webp', state.mane === o.id, priceTxt, false);
        b.onclick = function () { pick('mane', o.id); };
        host.appendChild(b);
      });
      echo('hhcfgPn-mane', u > 0 && DATA.manePriceNote ? DATA.manePriceNote.replace('{delta}', fmtDelta(u)) : '');
      echo('hhcfgEcho-mane', echoFor(by(CFG.manes, state.mane)));
    }
    function renderEyes() {
      /* eyes keep a price under every swatch (Pavel: Basic "Included", rest "+…") */
      var host = $('hhcfgOpts-eyes'); host.innerHTML = '';
      CFG.eyes.forEach(function (o) {
        var b = swBtn(o, 'sw_' + o.id + '.webp', state.eyes === o.id, o.incl ? DATA.included : fmtDelta(o.cents), false);
        b.onclick = function () { pick('eyes', o.id); };
        host.appendChild(b);
      });
      echo('hhcfgEcho-eyes', echoFor(by(CFG.eyes, state.eyes)));
    }
    function renderBlazes() {
      var host = $('hhcfgOpts-blaze'); host.innerHTML = '';
      var noFelt = feltBlocked();
      var note = $('hhcfgBlazeNote');
      if (note) { note.textContent = noFelt ? (DATA.noFeltNote || '') : ''; note.hidden = !noFelt || !DATA.noFeltNote; }
      CFG.blazes.forEach(function (o) {
        var off = noFelt && o.id !== 'none';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hhcfg-cardo' + (state.blaze === o.id ? ' on' : '') + (off ? ' na' : '');
        b.setAttribute('aria-pressed', state.blaze === o.id);
        if (off) b.setAttribute('aria-disabled', 'true');
        var cardSrc = (DATA.swatches && DATA.swatches[o.card.replace(/\.webp$/, '')]) || fileUrl(o.card, 400);
        b.innerHTML = '<span class="cim"><img src="' + cardSrc + '" alt="" loading="lazy"></span>' +
          '<b>' + o.label + '</b><span>' + (o.cents ? fmtDelta(o.cents) : DATA.included) + '</span>' + TICK;
        b.onclick = function () {
          if (off) { if (DATA.noFeltNote) toast(DATA.noFeltNote); return; }
          pick('blaze', o.id);
        };
        host.appendChild(b);
      });
      echo('hhcfgEcho-blaze', echoFor(by(CFG.blazes, state.blaze)));
    }

    /* ---------- summary ---------- */
    function renderSummary() {
      var m = by(CFG.manes, state.mane), e = by(CFG.eyes, state.eyes),
          bl = by(CFG.blazes, state.blaze), c = by(CFG.colors, state.color);
      function opt(o) {
        return o.label + (o.cents ? '<span class="delta">' + fmtDelta(o.cents) + '</span>' : '');
      }
      var rows = [
        [DATA.baseRowLabel.replace('{size}', by(CFG.sizes, state.size).label), '<em>' + fmtCents(DATA.basePriceCents) + '</em>'],
        [root.querySelector('#hhcfg-grp-color .hhcfg-gname').textContent, c.label],
        [root.querySelector('#hhcfg-grp-mane .hhcfg-gname').textContent, opt(m)],
        [root.querySelector('#hhcfg-grp-eyes .hhcfg-gname').textContent, opt(e)],
        [root.querySelector('#hhcfg-grp-blaze .hhcfg-gname').textContent, opt(bl)]
      ];
      $('hhcfgSumRows').innerHTML = rows.map(function (r) {
        return '<div class="hhcfg-sumr"><span>' + r[0] + '</span><span class="v">' + r[1] + '</span></div>';
      }).join('');
    }

    /* ---------- mock cart drawer (quantity fixed at 1) ---------- */
    function renderCart() {
      if (!state.inCart) return;
      var L = computeLayers(200);
      SLOTS.forEach(function (s) {
        var el = $('hhcfgD' + s);
        if (L[s]) { el.src = L[s]; el.classList.add('on'); }
        else { el.classList.remove('on'); el.removeAttribute('src'); }
      });
      var m = by(CFG.manes, state.mane), e = by(CFG.eyes, state.eyes),
          bl = by(CFG.blazes, state.blaze), c = by(CFG.colors, state.color);
      var bits = [by(CFG.sizes, state.size).label + ' &middot; ' + c.label,
        m.label + (m.cents ? ' <em>' + fmtDelta(m.cents) + '</em>' : ''),
        e.label + (e.cents ? ' <em>' + fmtDelta(e.cents) + '</em>' : '')];
      if (bl.id !== 'none') bits.push(bl.label + ' <em>' + fmtDelta(bl.cents) + '</em>');
      $('hhcfgDCfg').innerHTML = bits.join('<br>');
      $('hhcfgDLine').textContent = fmtCents(unitCents());
      $('hhcfgDSub').textContent = fmtCents(unitCents());
      $('hhcfgDCount').textContent = '(1)';
    }
    function openCart() { state.inCart = true; renderCart(); $('hhcfgOvl').classList.add('on'); $('hhcfgDrawer').classList.add('on'); }
    function closeCart() { $('hhcfgOvl').classList.remove('on'); $('hhcfgDrawer').classList.remove('on'); }

    /* ---------- zoom ---------- */
    function openZoom() {
      var L = computeLayers(1400);
      SLOTS.forEach(function (s) {
        var el = $('hhcfgZ' + s);
        if (L[s]) { el.src = L[s]; el.classList.add('on'); }
        else { el.classList.remove('on'); el.removeAttribute('src'); }
      });
      $('hhcfgZoom').classList.add('on');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeZoom() {
      $('hhcfgZoom').classList.remove('on');
      document.documentElement.style.overflow = '';
    }

    /* ---------- shuffle ---------- */
    function rnd(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
    var shuffling = false;
    function shuffleOnce() {
      state.color = rnd(CFG.colors.filter(colorSelectable)).id;
      state.mane = rnd(CFG.manes).id;
      state.eyes = rnd(CFG.eyes).id;
      state.blaze = rnd(CFG.blazes).id;
    }
    function shuffle() {
      if (shuffling) return;
      feedback();
      if (REDUCED) { shuffleOnce(); renderAll(); return; }
      shuffling = true;
      var steps = 3, i = 0;
      (function step() {
        shuffleOnce(); renderAll();
        if (++i < steps) setTimeout(step, 260);
        else shuffling = false;
      })();
    }

    /* ---------- share ---------- */
    function share() {
      persist();
      var url = location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () { /* dismissed */ });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { toast(DATA.shareToast); });
      } else {
        toast(url);
      }
    }

    /* ---------- misc ---------- */
    var toastT;
    function toast(msg) {
      var t = $('hhcfgToast'); t.textContent = msg; t.classList.add('on');
      clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2600);
    }
    function renderAll() {
      normalize();
      renderPreview(); renderPrice(); renderSizes(); renderColors(); renderManes();
      renderEyes(); renderBlazes(); renderSummary(); renderCart(); persist(); preload();
    }

    /* ---------- real add-to-cart (hidden pricing product) ---------- */
    function decodeEnt(s) {
      var t = document.createElement('textarea');
      t.innerHTML = s;
      return t.value;
    }
    /* Same sections and selectors the theme's own <atc-submit> asks for. */
    var CART_SECTIONS = [
      { id: 'cart-head', selectors: ['[data-render-util-cart-bubble]', '[data-render-cart-bubble]',
                                     '[data-render-sticky-cart-bubble]'] },
      { id: 'cart-inventory-organizer', selectors: ['#cart-items'] }
    ];
    /* global.js keeps sectionArrRender() in module scope, not on window, so these few
       lines are repeated here rather than reached for. */
    function renderCartSections(sections) {
      if (!sections) return;
      CART_SECTIONS.forEach(function (s) {
        var html = sections[s.id];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var src = parsed.getElementById(s.id) || parsed;
        s.selectors.forEach(function (sel) {
          var target = document.querySelector(sel), source = src.querySelector(sel);
          if (target && source) target.outerHTML = source.outerHTML;
        });
      });
    }
    function openThemeDrawer() {
      var toggler = document.querySelector('[data-modal-ref="modal-cart-drawer"][data-expanded="false"]');
      if (!toggler) return false;
      toggler.dispatchEvent(new Event('click', { bubbles: true }));
      return true;
    }
    var cartBusy = false;
    function setCartBusy(b) {
      cartBusy = b;
      ['hhcfgAtc', 'hhcfgAtcM', 'hhcfgShopPay'].forEach(function (id) {
        var e = $(id);
        if (e) { e.disabled = b; e.classList.toggle('busy', b); }
      });
    }
    function addToCart(toCheckout) {
      if (!CART) { openCart(); return; }   /* pricing product absent — mock drawer */
      if (cartBusy) return;
      var v = CART[comboKey()];
      if (!v) { toast(DATA.cartError); return; }
      setCartBusy(true);
      persist();
      /* Same property keys and English values as the CPB configurator, so
         fulfillment, notifications and hh-cart-translate keep working. */
      function grpLabel(id, fallback) {
        var el = root.querySelector('#hhcfg-grp-' + id + ' .hhcfg-gname');
        var t = el && el.textContent.trim();
        return t || fallback;
      }
      var props = {};
      props[grpLabel('size', 'Size')] = decodeEnt(by(CFG.sizes, state.size).label);
      props[grpLabel('color', 'Color')] = decodeEnt(by(CFG.colors, state.color).label);
      props[grpLabel('mane', 'Manes')] = decodeEnt(by(CFG.manes, state.mane).label);
      props[grpLabel('eyes', 'Eyes')] = decodeEnt(by(CFG.eyes, state.eyes).label);
      props[grpLabel('blaze', 'Blaze & Markings')] = decodeEnt(by(CFG.blazes, state.blaze).label);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: v.id, quantity: 1, properties: props }],
          sections: CART_SECTIONS.map(function (s) { return s.id; }),
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add ' + r.status);
        return r.json();
      }).then(function (res) {
        if (toCheckout) { window.location.href = '/checkout'; return; }
        renderCartSections(res && res.sections);
        setCartBusy(false);
        /* If the header has no drawer toggler, fall back to /cart rather than leaving
           the customer with a silently added item and no feedback. */
        if (!openThemeDrawer()) window.location.href = '/cart';
      }).catch(function () {
        setCartBusy(false);
        toast(DATA.cartError);
      });
    }

    $('hhcfgAtc').onclick = function () { addToCart(false); };
    $('hhcfgAtcM').onclick = function () { addToCart(false); };
    var sp = $('hhcfgShopPay');
    if (sp) sp.onclick = function () { addToCart(true); };
    $('hhcfgDClose').onclick = closeCart;
    $('hhcfgOvl').onclick = closeCart;
    $('hhcfgShare').onclick = share;
    $('hhcfgShuffle').onclick = shuffle;
    $('hhcfgExpand').onclick = openZoom;
    $('hhcfgZoom').onclick = function (ev) { if (ev.target.id !== 'hhcfgZoomStage') closeZoom(); };
    $('hhcfgZClose').onclick = closeZoom;
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') { closeZoom(); closeCart(); } });

    /* mobile: shrink the sticky preview once scrolled past it */
    var shrinkAt = 0;
    function measure() {
      var st = root.querySelector('.hhcfg-pstage');
      shrinkAt = st ? st.getBoundingClientRect().top + window.scrollY + 80 : 120;
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', function () {
      if (window.innerWidth > 991) { root.classList.remove('shrunk'); return; }
      root.classList.toggle('shrunk', window.scrollY > shrinkAt);
    }, { passive: true });

    /* idle-preload the felt-aware variants of the current mane+base */
    var preloaded = {}, feltWarmed = {};
    function warm(states) {
      var run = function () {
        states.forEach(function (s) {
          var u = fileUrl(state.mane + '__' + state.color + s + '.webp', LAYER_W);
          if (u) { var i = new Image(); i.src = u; }
        });
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2500 });
      else setTimeout(run, 900);
    }
    /* Eager: only the plain layer, which the stage is about to show anyway. */
    function preload() {
      if (!LIVEPREV) return;
      var pair = state.mane + '|' + state.color;
      if (preloaded[pair]) return;
      preloaded[pair] = 1;
      warm(['']);
    }
    /* Deferred: the four felt-aware variants, ~500 KB each, only once the shopper actually
       reaches the felt group. Bound once; the group element survives re-renders. */
    function warmFelt() {
      if (!LIVEPREV || feltBlocked()) return;
      var pair = state.mane + '|' + state.color;
      if (feltWarmed[pair]) return;
      feltWarmed[pair] = 1;
      warm(['_bl', '_mk', '_bm', '_st']);
    }
    var feltGroup = root.querySelector('#hhcfg-grp-blaze');
    if (feltGroup) {
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) {
        feltGroup.addEventListener(ev, warmFelt, { passive: true });
      });
    }
    renderAll();
  }

  function boot() { document.querySelectorAll('.hhcfg').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
